import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ items }) => (
  <div className="py-10 border-y border-[#B7926A]/30 bg-[#D9C3A8]/40" data-testid="editorial-marquee">
    <Marquee speed={26} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-10 inline-flex items-center gap-10">
          <span className="font-display italic text-4xl sm:text-6xl text-[#47394E] tracking-tight">
            {t}
          </span>
          <span className="text-[#B7926A] text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
